import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { from, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UINotificationService } from '../services';
import { Router } from '@angular/router';

@Injectable()
export class ErrorHttpInterceptor implements HttpInterceptor {
  constructor(private notificationService: UINotificationService, private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    return from(this.handleAccess(request, next));
  }

  private async handleAccess(request: HttpRequest<any>, next: HttpHandler) {
    return next
      .handle(request)
      .pipe(
        tap(
          result => {},
          error => {
            console.log(error);
            if (error instanceof HttpErrorResponse) {
              this.handleError(error);
              switch (error.status) {
                case 403:
                  return this.router.navigate(['./not-authorized']);
                case 401:
                  return this.router.navigate(['./login']);

                default:
                  break;
              }
            } else {
              return throwError(error);
            }
          },
          () => {}
        )
      )
      .toPromise();
  }

  private handleError(error: HttpErrorResponse) {
    if (typeof error?.error?.error?.message === 'string') {
      this.notificationService.showSimpleSnack(error?.error?.error?.message, true);
    }
    if (typeof error?.error?.error?.validationErrors === 'object') {
      let msg = '';
      error?.error?.error?.validationErrors.forEach(element => {
        msg += element.name + ': ' + element.reason + '  ';
      });

      this.notificationService.showSimpleSnack(msg, true);
    }
    if (error?.error?.message) {
      this.notificationService.showSimpleSnack(error?.error?.message, true);
    }
  }
}
